import React, { useEffect, useRef } from "react"
import ReactDOM from "react-dom"
import useVisibilitySensor from "@rooks/use-visibility-sensor"
import "./animation.css"

export const getTitles = () => {
  //get elements
  let greyBg = document.getElementsByClassName("grey-bg")
  let blackBg = document.getElementsByClassName("black-bg")

  Array.from(greyBg).map((value, index) => {
    let span = value.childNodes[0] //get span
    let text = span.textContent // get text
    let clas = value.classList.value
    value.classList.replace(clas, "title_default_white")


    //remove info from parent node
    span.remove() // or value.removeChild();

    //create holder div
    var div = document.createElement("span")
    ReactDOM.render(
      <TitleDoc parentElement={value} text={text} clas={clas}></TitleDoc>,
      value
    )
  })

  Array.from(blackBg).map((value, index) => {
    
    let span = value.childNodes[0] //get span
  let text = span.textContent // get text
  //  let text = span.innerText
    let clas = value.classList.value

    value.classList.replace(clas, "title_default_black")

    var text1 = ""
    if(value.childNodes[1]) text1 = value.childNodes[1].textContent.trim() 
    
    

    //remove info from parent node
    span.remove() // or value.removeChild();

    //create holder div
    var div = document.createElement("span")
    ReactDOM.render(
      <TitleDoc parentElement={value} text={text} clas={clas} extra={text1}></TitleDoc>,
      value
    )
  })
}

let TitleDoc = ({ parentElement, text, clas, extra }) => {
  const rootNode = useRef(null)
  const { isVisible, visibilityRect } = useVisibilitySensor(rootNode, {
    intervalCheck: 100,
    scrollCheck: true,
    resizeCheck: true,
  })

  if (rootNode.current != null)
    if (isVisible) {
      parentElement.classList.add(clas != "black-bg" ? "title_shown_black" : "title_shown_white")
    } else {
      parentElement.classList.remove(
        clas != "black-bg" ? "title_shown_black" : "title_shown_white"
      )
    }

  return (
    <span ref={rootNode}>
      <span >{text}</span>
      {extra && <sup>{extra}</sup> }
    </span>
  )
}
